resourcePaths = '{"rootPath":"/member","assetsPath":"/member/assets"}';/*
    ContentfulConfiguration

    Object that specifies configuration options for Contentful.
*/
var _ContentfulConfiguration = {
  url: 'https://cdn.contentful.com',
  resolve_links: '5',
  environment_id: 'master',
  resources: {
    SPACE: {
      url: '/spaces/{space_id}/environments/{environment_id}'
    },
    CONTENT_MODELS: {
      url: '/spaces/{space_id}/environments/{environment_id}/content_types'
    },
    CONTENT_MODEL: {
      url: '/spaces/{space_id}/environments/{environment_id}/content_types/{model_id}'
    },
    ALL_ENTRIES: {
      url: '/spaces/{space_id}/environments/{environment_id}/entries?include={resolve_links}'
    },
    ENTRIES_FROM_MODEL: {
      url: '/spaces/{space_id}/environments/{environment_id}/entries?include={resolve_links}&content_type={model_id}'
    },
    ENTRIES_FROM_MODEL_ORDERED: {
      url: '/spaces/{space_id}/environments/{environment_id}/entries?include={resolve_links}&content_type={model_id}&order={order}'
    },
    ENTRIES_FROM_MODEL_BY_NAME: {
      url:
        '/spaces/{space_id}/environments/{environment_id}/entries?include={resolve_links}&content_type={model_id}&fields.name={name_value}'
    },
    LOCALIZED_ENTRIES_FROM_MODEL_BY_NAME: {
      url:
        '/spaces/{space_id}/environments/{environment_id}/entries?include={resolve_links}&content_type={model_id}&fields.name={name_value}&locale={locale}'
    },
    ENTRIES_FROM_MODEL_BY_ID: {
      url:
        '/spaces/{space_id}/environments/{environment_id}/entries?include={resolve_links}&content_type={model_id}&fields.id={name_value}'
    },
    ENTRY: {
      url: '/spaces/{space_id}/environments/{environment_id}/entries?sys.id={entry_id}&include={resolve_links}'
    }
  }
};
